import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import "./ChatBox.css";
import backIcon from '../images/back.png';
import cancelIcon from '../images/cancel.png';

const ChatBox = ({onClose}) => {
  const [message, setMessage] = useState('');
  const [chat, setChat] = useState([]);
  const [inbox, setInbox] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const messageEndRef = useRef(null);
  const navigate = useNavigate();

  const senderId = localStorage.getItem('userId');  

  useEffect(() => {
    if (!senderId) {
      navigate('/login');
      return;
    }
    fetchInbox();
  }, []);
  
  useEffect(() => {
    const handleOpenChat = () => {
      const selectedUserFromStorage = localStorage.getItem("selectedUser");
      if (selectedUserFromStorage) {
        setSelectedUser(JSON.parse(selectedUserFromStorage));
      }
    };
  
    window.addEventListener("openChatBox", handleOpenChat);
    // Trigger immediately if already selectedUser exists in storage
    const storedUser = localStorage.getItem("selectedUser");
    if (storedUser && !selectedUser) {
      setSelectedUser(JSON.parse(storedUser));
    }
  
    return () => {
      window.removeEventListener("openChatBox", handleOpenChat);
    };
  }, []);
  
  useEffect(() => {
    const interval = setInterval(() => {
      fetchInbox();
    }, 5000); // refresh inbox every 5 seconds
  
    return () => clearInterval(interval);
  }, []);
  const fetchInbox = async () => {
    try {
      const res = await axios.get(`https://shubhjiwan.co.in/ShubhJiwan_backend11/getinbox.php?user_id=${senderId}`);
      setInbox(res.data);
    } catch (err) {
      console.error("Inbox fetch error:", err);
    }
  };

  const fetchMessages = async (receiverId) => {
    try {
      const res = await axios.get(`https://shubhjiwan.co.in/ShubhJiwan_backend11/getmessages.php?sender_id=${senderId}&receiver_id=${receiverId}`);
      setChat(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  const sendMessage = async () => {
    if (message.trim() && selectedUser) {
      try {
        await axios.post('https://shubhjiwan.co.in/ShubhJiwan_backend11/sendMessages.php', {
          sender_id: senderId,
          receiver_id: selectedUser.id,
          message,
        });
        setMessage('');
        fetchMessages(selectedUser.id);
      } catch (err) {
        console.error("Send message error:", err);
      }
    }
  };

  useEffect(() => {
    if (selectedUser) {
      fetchMessages(selectedUser.id);
      const interval = setInterval(() => fetchMessages(selectedUser.id), 3000);
      return () => clearInterval(interval);
    }
  }, [selectedUser]);

  useEffect(() => {
    messageEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chat]);

  if (!senderId) {
    navigate('/login');
    return null;
  }

  return (
    <div className="chat-container relative">
    {!selectedUser ? (
      <div className="inbox-list relative">
        <h2 className="chat-header">Chats</h2>
  
        <button 
          onClick={onClose}
          className="cancel-button absolute top-4 right-4"
        >
          <img 
            src={cancelIcon}
            alt="Cancel"
            className="w-8 h-8"
          />
        </button>
  
        {inbox.map((user, index) => (
          <div
            key={index}
            className="inbox-item"
            onClick={() => {
              localStorage.setItem("selectedUser", JSON.stringify(user));
              setSelectedUser(user);
            }}
          >
            <div className="inbox-avatar">
              {user.profile_image ? (
                <img
                  src={`https://shubhjiwan.co.in/ShubhJiwan_backend11/serve_image.php?file=${encodeURIComponent(user.profile_image)}`}
                  alt="avatar"
                />
              ) : (
                <div className="avatar-placeholder">
                  {user.name?.charAt(0).toUpperCase()}
                </div>
              )}
            </div>
            <div className="inbox-details">
              <div className="inbox-top">
                <span className="inbox-name">{user.name || `User ${user.id}`}</span>
                <span className="inbox-time">{user.last_time}</span>
              </div>
              <div className="inbox-bottom">
                <span className="last-message">{user.last_message}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    ) : (
      <>
        {/* Chat Header with Buttons */}
        <div className="chat-header flex items-center justify-between px-4 py-3 border-b relative bg-white shadow-sm">
          <div className="flex items-center gap-2">
            <button onClick={() => setSelectedUser(null)} className="back-button">
              <img src={backIcon} alt="Back" className="w-6 h-6" />
            </button>
            <img
              src={
                selectedUser.profile_image
                  ? `https://shubhjiwan.co.in/ShubhJiwan_backend11/serve_image.php?file=${encodeURIComponent(selectedUser.profile_image)}`
                  : "default-avatar.png"
              }
              alt="Profile"
              className="w-8 h-8 rounded-full"
            />
            <span className="font-semibold">{selectedUser.name}</span>
          </div>
  
          <button onClick={onClose} className="cancel-button">
            <img src={cancelIcon} alt="Cancel" className="w-7 h-7" />
          </button>
        </div>
  
        {/* Chat Messages */}
        <div className="chat-messages p-4 overflow-y-auto flex-1">
          {chat.map((msg, index) => (
            <div
              key={index}
              className={`chat-bubble ${
                parseInt(senderId) === parseInt(msg.sender_id) ? "sent" : "received"
              }`}
            >
              {msg.message}
            </div>
          ))}
          <div ref={messageEndRef} />
        </div>
  
        {/* Chat Input */}
        <div className="chat-input-area flex items-center px-4 py-3 border-t bg-white">
          <input
            type="text"
            className="chat-input flex-1 p-2 border rounded-lg mr-2"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type a message..."
          />
          <button className="chat-send-button px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600" onClick={sendMessage}>
            Send
          </button>
        </div>
      </>
    )}
  </div>
  
  );
};
export default ChatBox;